import { AppDomainConstant } from "src/app/constants/apis/app-domain.constant";

export class GestionUsuarioApiConstant {
  static readonly GESTION_USUARIOS: string = "api/v1/users-management/";

  static readonly BASE_PARAMETRIZACION: string = "api/v1/parametrizaciones/";

  static readonly GESTION_PRIVILEGIOS: string = "api/v1/privileges/";

  static readonly GESTION_BUC: string = "api/v1/buc/federacion/";

  static readonly GET_ESTADOS: string = "change-status/reason";

  static readonly GET_MOTIVO_ESTADO: string = "motivo-estado";

  static readonly ID_ESTADO: string = "cambio-estado/motivo";

  static readonly UPDATE_ESTADOS: string = "change-status";

  static readonly DISTRIBUIDORES: string =
    "api/v1/multiempresa/distribuidores/";

  static readonly TIPO_DOCUMENTO: string =
    GestionUsuarioApiConstant.GESTION_USUARIOS + "documents-type";

  static readonly ALL_DISTRIBUIDOR: string =
    GestionUsuarioApiConstant.DISTRIBUIDORES + "all";
    static readonly BUC_LANDING_PAGE_CONFIG: string = GestionUsuarioApiConstant.GESTION_BUC + 'landing-page-config';


  static readonly USUARIO: string =
    GestionUsuarioApiConstant.GESTION_USUARIOS + "users";

  static readonly PRIVILEGIOS: string =
    GestionUsuarioApiConstant.GESTION_PRIVILEGIOS + "roles";

  static readonly BUC: string =
    GestionUsuarioApiConstant.GESTION_BUC + "client";

  static readonly BUC_VALIDATION: string = GestionUsuarioApiConstant.GESTION_BUC + 'client/validation';

  static readonly URL_TIPO_DOCUMENTO: string =
    AppDomainConstant.URI_GATEWAY + GestionUsuarioApiConstant.TIPO_DOCUMENTO;

  static readonly URL_DISTRIBUIDOR: string =
    AppDomainConstant.URI_GATEWAY + GestionUsuarioApiConstant.ALL_DISTRIBUIDOR;

  static readonly URL_USUARIO: string =
    AppDomainConstant.URI_GATEWAY + GestionUsuarioApiConstant.USUARIO;

  static readonly URL_PRIVILEGIOS: string =
    AppDomainConstant.URI_GATEWAY + GestionUsuarioApiConstant.PRIVILEGIOS;

  static readonly URL_BUC: string =
    AppDomainConstant.URI_GATEWAY + GestionUsuarioApiConstant.BUC;

  static readonly URL_BUC_VALIDATION: string =
    AppDomainConstant.URI_GATEWAY +
    GestionUsuarioApiConstant.BUC_VALIDATION;

  static readonly URL_ID_ESTADO_USUARIO: string =
    AppDomainConstant.URI_GATEWAY +
    GestionUsuarioApiConstant.USUARIO +
    GestionUsuarioApiConstant.ID_ESTADO;

  static readonly URL_ESTADOS_USUARIO: string =
    AppDomainConstant.URI_GATEWAY +
    GestionUsuarioApiConstant.GESTION_USUARIOS +
    GestionUsuarioApiConstant.GET_ESTADOS;

  static readonly URL_MOTIVO_ESTADO_USUARIO: string =
    AppDomainConstant.URI_GATEWAY +
    GestionUsuarioApiConstant.BASE_PARAMETRIZACION +
    GestionUsuarioApiConstant.GET_MOTIVO_ESTADO;

  static readonly URL_UPDATE_ESTADO_USUARIO: string =
    AppDomainConstant.URI_GATEWAY +
    GestionUsuarioApiConstant.GESTION_USUARIOS +
    GestionUsuarioApiConstant.UPDATE_ESTADOS;

  static readonly URL_BUC_LANDING_PAGE_CONFIG: string =
        AppDomainConstant.URI_GATEWAY +
        GestionUsuarioApiConstant.BUC_LANDING_PAGE_CONFIG;
}

